/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger': {
    width: 16,
    height: 16,
    viewBox: '0 0 40 18',
    data: '<path pid="0" d="M1 1h30M9 9h30M1 17h30" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
